import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppSeoLocationPageComponent } from './app-seo-location-page/app-seo-location-page.component';
import { SeoLocationPageResolve } from '../../core/services/seo-location-page.resolve';
import { CharterBuyflowVesselsResolve } from '../public/charter-buyflow/charter-buyflow-vessels/charter-buyflow-vessels.resolve';

const routes: Routes = [
  {
    path: '',
    component: AppSeoLocationPageComponent,
    resolve: {
      SeoLocationPageResolve: SeoLocationPageResolve,
      resolvedData: CharterBuyflowVesselsResolve,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SeoRoutingModule {}
